/* eslint-disable react/no-unknown-property */
import React, { useState, useRef, useEffect } from "react";
import { Typography } from "@mui/material";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const RoomsAndDetails = ({ errors, handleInputChange, data, subDataName, info, submitted }) => {
    const [expanded, setExpanded] = useState(data?.length === 1 ? 0 : null);

    const handleAccordionChange = (index) => {
        setExpanded(expanded === index ? null : index);
    };

    return (
        <div className="d-flex gap-2 flex-column mt-2">
            {
                data?.map((counter, roomIndex) => (
                    <div key={roomIndex} className={`d-flex gap-1 ${expanded === roomIndex ? "align-items-start" : "align-items-center"}`}>
                        <Accordion
                            key={roomIndex}
                            expanded={expanded === roomIndex}
                            onChange={() => handleAccordionChange(roomIndex)}
                            style={{ width: "100%", borderRadius: "8px", border: "1px solid #7575753b" }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`room-3-content`}
                                id={`room-3-header`}
                                style={{ display: "flex", alignItems: "center" }}
                            >
                                {/* Left Side - Room Icon and Details */}
                                <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                                    {/* Bed Icon with Lamp */}
                                    <img
                                        src="/icon/rooms.svg"
                                        alt="bed"
                                        style={{ width: "40px", height: "40px" }}
                                    />

                                    {/* Room Details */}
                                    <div className="text-start">
                                        <Typography fontWeight={600}>{`Room ${roomIndex + 1}`}</Typography>
                                        {/* <Typography variant="body2" color="gray">
                              {`Adult-${counter.adults}`} | {`Children-${counter.children}`}
                            </Typography> */}
                                    </div>
                                </div>
                            </AccordionSummary>

                            <AccordionDetails>
                                {counter?.[subDataName]?.map((person, personIndex) => (
                                    <>
                                        <div key={personIndex} className="row pt-2 d-flex align-items-end flex-wrap gap-2 gap-md-0">
                                            {/* Type Selection */}
                                            <div className="col-md-2">
                                                <div className="form-input input-style border h-100">
                                                    <select
                                                        value={person.type}
                                                        disabled
                                                        onChange={(e) =>
                                                            handleInputChange(roomIndex, personIndex, "type", e.target.value)
                                                        }
                                                    >
                                                        <option value="adult">Adult</option>
                                                        <option value="child">Children</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Title Selection */}
                                            <div className="col-md-2">
                                                <div className="form-input input-style border h-100">
                                                    <select
                                                        value={person.title}
                                                        onChange={(e) =>
                                                            handleInputChange(roomIndex, personIndex, "title", e.target.value)
                                                        }
                                                    >
                                                        <option value="Mr">Mr.</option>
                                                        <option value="Ms">Ms.</option>
                                                        <option value="Miss">Miss.</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {/* First Name */}
                                            <div className="col-md-3">
                                                <div className="form-input">
                                                    <input
                                                        type="text"
                                                        value={person.firstName}
                                                        placeholder="First Name"
                                                        style={{ paddingTop: "0px", minHeight: "46px" }} // Adjust height as needed
                                                        onChange={(e) =>
                                                            handleInputChange(roomIndex, personIndex, "firstName", e.target.value)
                                                        }
                                                    />
                                                    {/* <label className="lh-1 text-16 text-light-1">First Name</label> */}
                                                    {info && <p style={{ color: "#DC3545" }}>{info}</p>}
                                                </div>
                                                {/* {submitted && errors[`firstName_${roomIndex}_${personIndex}`] && (
                                                    <p style={{ color: "#DC3545" }}>
                                                        {errors[`firstName_${roomIndex}_${personIndex}`]}
                                                    </p>
                                                )} */}
                                            </div>

                                            {/* Last Name */}
                                            <div className="col-md-3">
                                                <div className="form-input">
                                                    <input
                                                        type="text"
                                                        value={person.lastName}
                                                        placeholder="Last Name"
                                                        style={{ paddingTop: "0px", minHeight: "46px" }} // Adjust height as needed
                                                        onChange={(e) =>
                                                            handleInputChange(roomIndex, personIndex, "lastName", e.target.value)
                                                        }
                                                    />
                                                    {/* <label className="lh-1 text-16 text-light-1">Last Name</label> */}
                                                    {info && <p style={{ color: "#DC3545" }}>{info}</p>}
                                                </div>
                                                {/* {submitted && errors[`lastName_${roomIndex}_${personIndex}`] && (
                                                    <p style={{ color: "#DC3545" }}>
                                                        {errors[`lastName_${roomIndex}_${personIndex}`]}
                                                    </p>
                                                )} */}
                                            </div>

                                            {/* Age Field (only for children) */}
                                            {person.type === "child" && (
                                                <div className="col-md-2">
                                                    <div className="form-input">
                                                        {/* <label className="lh-1 text-15 text-light-1" style={{ top: "10px" }}>Age</label> */}
                                                        <input
                                                            style={{ fontSize: "13px", paddingTop: "0px", minHeight: "46px" }}
                                                            type="text"
                                                            value={person.age?.name}
                                                            placeholder="Age"
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div key={personIndex} className="row pb-2 d-flex align-items-end flex-wrap">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-2"></div>
                                            <div className="col-md-3">
                                                {submitted && errors[`firstName_${roomIndex}_${personIndex}`] && (
                                                    <p style={{ color: "#DC3545" }}>
                                                        {errors[`firstName_${roomIndex}_${personIndex}`]}
                                                    </p>
                                                )}
                                            </div>
                                            <div className="col-md-3">
                                                {submitted && errors[`lastName_${roomIndex}_${personIndex}`] && (
                                                    <p style={{ color: "#DC3545" }}>
                                                        {errors[`lastName_${roomIndex}_${personIndex}`]}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </AccordionDetails>


                        </Accordion>
                    </div>
                ))
            }
        </div>
    );
};

export default RoomsAndDetails;
